import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import moment from 'moment';

import { ElementLink, Dialog } from '../../components';
import { deleteQrCode } from '../../mutations';

function formatDate(date) {
  return moment(date).format('MM-DD-YYYY h:mm a');
}

export class QrCodeCellView extends Component {
  state = {
    showsDeleteDialog: false,
  };

  handleDeleteClicked = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showsDeleteDialog: true });
  };

  handleCancelDelete = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showsDeleteDialog: false });
  };

  handleConfirmDelete = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ showsDeleteDialog: false });

    const { lists, qrCode, relay } = this.props;
    deleteQrCode(relay.environment, qrCode.id, lists.id, {
      onError: this.handleSubmitFailure,
    });
  };

  handleSubmitFailure = (err) => {
    console.error(err.message);
  };

  render() {
    const { showsDeleteDialog } = this.state;
    const { qrCode } = this.props;

    return (
      <ElementLink
        element="tr"
        to={`/qr-codes/${qrCode.id}`}
        className="qr-code-cell"
      >
        <td className="qr-code-cell-createdAt">
          {formatDate(qrCode.createdAt)}
        </td>
        <td className="qr-code-cell-sign">
          {qrCode.sign}
          <Dialog
            className="deletion"
            isOpen={showsDeleteDialog}
            message={`'Are you sure you want to remove QR code ${qrCode.sign}?`}
            onConfirm={this.handleConfirmDelete}
            onCancel={this.handleCancelDelete}
          />
          <a
            className="qr-code-delete-button"
            onClick={this.handleDeleteClicked}
          >
            ✘
          </a>
        </td>
      </ElementLink>
    );
  }
}

export default createFragmentContainer(QrCodeCellView, {
  qrCode: graphql`
    fragment QrCodeCell_qrCode on QrCode {
      id
      createdAt
      sign
    }
  `,
});
